<template>
  <section>
	  <div class='container-fluid' id='footer'>

      <!-- Logos -->
      <div class='container'>									          
		    <div class='row' style='padding-top: 40px;'>
          <div class='col-12'>							
					<p>Built in Sydney, by mortgage brokers for mortgage brokers and their customers.</p>
					<p>We strive to ensure that information displayed on our website is as accurately as possible, however we do not warrant that the information is accurate. 
					Where we become aware of any incorrect information, we reserve the right to correct any error or omission.</p>
				
					<p>Office Address 16/9 Castlereagh Street, Sydney NSW 2000<br>  
					&#169; 2024 My Shortcut Pty Ltd ABN 43 658 619 982</p>
				</div>
				
				<div class='col-12'>
					<p>This site contains logos all of which are copyright of their associated bank or lender.  No infringement of copyright is intended. If anything on the site breaches your copyright, please let us know, and we will remove the offending material.</p>
				</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default 
  { name: 'FooterPage' }
</script>